export enum FeeDefinitionType {
    Transaction = 'transaction',
    Financing = 'financing',
    CurrencyConversion = 'currency-conversion',
    Subscription = 'subscription',
    Refund = 'refund',
}
